import React from "react";
import useStyles from "../../styles";
import { Grid, IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/CloseOutlined";
import { Images } from "config/images";

const UploadImageDelete = props => {
	const {
		handleUploadImage,
		type,
		children,
		image,
		handleDeleteImage,
		businessForm
	} = props;
	const classes = useStyles();
	return (
		<React.Fragment>
			<input
				type="file"
				hidden
				onChange={e => {
					handleUploadImage(e, type);
				}}
				id={type}
				multiple={false}
				accept="image/*"
				capture="environment"
			/>
			<Grid classes={{ root: classes.camera }}>
				{image && (
					<IconButton
						classes={{
							root: classes.btnCloseImage
						}}
						onClick={() => handleDeleteImage(type)}
					>
						<CloseIcon />
					</IconButton>
				)}
				<label htmlFor={type} className={classes.btnDefaultCamera}>
					{image ? (
						<React.Fragment>
							<img
								src={image}
								alt={type}
								className={classes.imageIdentityCard}
							/>
						</React.Fragment>
					) : (
						<React.Fragment>
							<img
								src={
									businessForm === "INDIVIDUAL"
										? Images.icCameraV2
										: Images.icCameraAdd
								}
								alt={
									businessForm === "INDIVIDUAL"
										? "icCameraV2"
										: "icCameraAdd"
								}
							/>
							<Grid style={{ marginTop: 5 }}>{children}</Grid>
						</React.Fragment>
					)}
				</label>
			</Grid>
		</React.Fragment>
	);
};

export default UploadImageDelete;
